export const CUSTOM_VWAP_NEUTRAL = '#2dd4bf'
const positivePrice = value => Number.isFinite(value) && value > 0

// Capture the selected candle once. Display-timeframe aggregation must never
// move the reference price or retroactively change existing anchor defaults.
export function newCustomVwapAppearance(candle) {
  const prices = [candle?.open, candle?.high, candle?.low, candle?.close]
  const anchorPrice = prices.every(positivePrice) ? prices.reduce((sum, price) => sum + price / 4, 0) : null
  return { colorMode: 'dynamic', anchorPrice, lineWidth: 2 }
}

export function customVwapColor(appearance = {}, currentPrice) {
  appearance ||= {}
  if (appearance.colorMode !== 'dynamic') return appearance.color || CUSTOM_VWAP_NEUTRAL
  if (!positivePrice(appearance.anchorPrice) || !positivePrice(currentPrice) || currentPrice === appearance.anchorPrice) return CUSTOM_VWAP_NEUTRAL
  return currentPrice > appearance.anchorPrice ? '#22c55e' : '#ef4444'
}
